(() => {
  const targetId = 'ContactForm';
  const buttonId = 'js-submit-button';
  const target = document.getElementById(targetId);
  const $target = $(`#${targetId} :input`);
  const button = document.getElementById(buttonId);
  const checkBoxElementNameList = [
    'contact[当社製品をどちらでお知りになりましたか]',
    'contact[ご来場の目的をお選びください]',
    'contact[資料形式]',
    'contact[お問合せ内容]',
  ];

  const googleAppsScriptUrl ='https://script.google.com/macros/s/AKfycbyTvFoDC-aBoUFN3FFdAEgdDZYbvPZMJb1Rd840NMKv-3UMtK2V1pdyiBXTj02FbccD/exec';

  /**
   * @param {array} formArray [{name: 'name', value: 'value'}]
   * @return {object}  {'name': 'value'}
   */
  const objectifyForm = (formArray) => {
    const returnObject = {};
    for (let i = 0; i < formArray.length; i++) {
      if (checkBoxElementNameList.includes(formArray[i]['name'])) {
        if (!returnObject[formArray[i]['name']]) {
          returnObject[formArray[i]['name']] = formArray[i]['value'] + ',';
        } else {
          returnObject[formArray[i]['name']] += formArray[i]['value'] + ',';
        }
      } else {
        returnObject[formArray[i]['name']] = formArray[i]['value'];
      }
    }
    return returnObject;
  };

  const getRedirectUrl = () => {
    const url = location.href;
    const urlParam = location.search.substring(1);
    if (!urlParam) {
      return `${url}?contact_posted=true`;
    }
    if (!urlParam.match(/contact_posted=true/)) {
      return `${url}&contact_posted=true`;
    }
    return url;
  };

  const redirect = (url) => {
    location.href = url;
  };

  window.addEventListener('DOMContentLoaded', () => {
    if (!target) {
      return;
    }

    /* ===== 資料形式（紙 / PDF）選択の保存 ===== */
    const radios = document.querySelectorAll('input[name="contact[資料受取形式]"]');
    const hidden = document.getElementById('js-doc-type-hidden');

    radios.forEach(radio => {
      radio.addEventListener('change', function () {
        if (hidden) {
          hidden.value = this.value;
        }
        localStorage.setItem('contact_doc_type', this.value);
      });
    });

    const customerRadios = document.querySelectorAll('input[name="contact[お客様区分]"]');

    customerRadios.forEach(radio => {
      radio.addEventListener('change', function () {
        localStorage.setItem('contact_customer_type', this.value);
      });
    });

    /* ===== 送信後：PDF選択ならDLボタン表示 ===== */
    const pdfArea = document.getElementById('pdf-download-area');
    const docType = localStorage.getItem('contact_doc_type');
    const customerType = localStorage.getItem('contact_customer_type');
    const hideTargets = document.querySelectorAll('.field_group, .form_field_2_column, #js-submit-button');

    if (pdfArea && docType === 'PDF' && customerType === '個人') {
      pdfArea.style.display = 'block';
      hideTargets.forEach(el => {
        el.style.display = 'none';
      });
    } else if (pdfArea) {
      pdfArea.style.display = 'none';
    }

    const statusMessage = document.querySelector('.contact_status .form-message');
    if (statusMessage) {
      if (docType === 'PDF' && customerType === '個人') {
        statusMessage.textContent = 'お問い合わせをいただき、ありがとうございます。';
      }
    }

    target.addEventListener('submit', (event) => {
      event.preventDefault();
      button.disabled = true;
      const formObject = objectifyForm($target.serializeArray());
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(key => {
        const value = sessionStorage.getItem(key);
        if (value !== null && value.trim() !== '') {
          formObject[key] = value;
        }
      });
      const postParameter = {
        method: 'POST',
        mode: 'no-cors',
        'Content-Type': 'text/plain',
        keepalive: true,
        body: JSON.stringify(formObject),
      };
      fetch(googleAppsScriptUrl, postParameter).finally(() => {
        redirect(getRedirectUrl());
      });
    });
  });
})();
